var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLeaders = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_70_82094)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3338 7.37679L18.8632 2.56872C17.0959 1.5656 14.9041 1.5656 13.1368 2.56872L4.66624 7.37679C2.94141 8.35583 1.88235 10.1426 1.88235 12.0736V21.9264C1.88235 23.8574 2.94141 25.6442 4.66624 26.6232L13.1368 31.4313C14.9041 32.4344 17.0959 32.4344 18.8632 31.4313L27.3338 26.6232C29.0586 25.6442 30.1176 23.8574 30.1176 21.9264V12.0736C30.1176 10.1426 29.0586 8.35583 27.3338 7.37679ZM19.8176 1.00312C17.4612 -0.334374 14.5388 -0.334373 12.1824 1.00312L3.71185 5.81118C1.41207 7.11658 0 9.49894 0 12.0736V21.9264C0 24.5011 1.41208 26.8834 3.71185 28.1888L12.1824 32.9969C14.5388 34.3344 17.4612 34.3344 19.8176 32.9969L28.2882 28.1888C30.5879 26.8834 32 24.5011 32 21.9264V12.0736C32 9.49895 30.5879 7.11658 28.2882 5.81118L19.8176 1.00312Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5528 7.94744L16.0156 5H15.9844L14.4472 7.94744L11.0096 8.42014L11 8.44798L13.4875 10.7425L12.9002 13.9832L12.9247 14L16 12.47L19.0753 14L19.0998 13.9832L18.5125 10.7425L21 8.44798L20.9905 8.42014L17.5528 7.94744Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 19.8242H12.2969V23.5748H7V19.8242Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 24.6289H12.2969V26.0003H7V24.6289Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3516 16.2266H18.6484V23.5745H13.3516V16.2266Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3516 24.6289H18.6484V26.0003H13.3516V24.6289Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7031 18.1602H25V23.5742H19.7031V18.1602Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7031 24.6289H25V26.0003H19.7031V24.6289Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_70_82094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 34,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLeaders);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/leaders.9b63bd18a720e91f0f9674d4a600d731.svg";